import $ from 'jquery';

import {
  EVENT_LISTENER_DEBOUNCE, SETTIMEOUT_MAXIMUM,
} from '~/dashboard/components/SessionManagement';
import { ajaxFetch, buildURLParamsString } from '~/helpers/api';
import { routes } from '~/helpers/routes';


// When an input change, set data-dirty attribute on its form.
function formChange(e) {
  $(e.target).closest('form').attr('data-dirty', true);
}


// When a form is submitted or resetted, unset data-dirty attribute.
function formClean(e) {
  $(e.target).removeAttr('data-dirty');
}


export default class SessionSecurity {
  constructor(options) {
    // Session security constructor. These are the required options:
    //
    // - pingUrl: url to ping with last activity in this tab to get global last
    //   activity time,
    // - warnAfter: number of seconds of inactivity before warning,
    // - expireAfter: number of seconds of inactivity before expiring the session.
    //
    // Optional options:
    //
    // - confirmFormDiscard: message that will be shown when the user tries to
    //   leave a page with unsaved form data. Setting this will enable an
    //   onbeforeunload handler that doesn't block expire().
    // - events: a list of event types to watch for activity updates.
    // - returnToUrl: a url to redirect users to expired sessions to.
    // If this is not defined we just reload the page

    // **HTML element** that should show to warn the user that his session will
    // expire.
    this.$warning = $('#session_security_warning');

    // Last recorded activity datetime.
    this.lastActivity = new Date();

    // Events that would trigger an activity
    this.events = ['mousemove', 'scroll', 'keyup', 'click'];

    // Merge the options dict here.
    $.extend(this, options);

    // Bind activity events to update this.lastActivity.
    const resetLastActivity = () => {
      const now = new Date();
      if (now - this.lastActivity < EVENT_LISTENER_DEBOUNCE) return;
      // Throttle these checks to once per second

      this.lastActivity = now;

      if (this.$warning.is(':visible')) {
        // Inform the server that the user came back manually, this should
        // block other browser tabs from expiring.
        this.ping();
      }

      this.hideWarning();
    };
    for (let i = 0; i < this.events.length; i += 1) {
      $(document)[this.events[i]](resetLastActivity);
    }

    // Initialize timers.
    this.apply();

    if (this.confirmFormDiscard) {
      window.onBeforeUnload = this.onBeforeUnload.bind(this);

      $(document).on('change', ':input', formChange);
      $(document).on('submit', 'form', formClean);
      $(document).on('reset', 'form', formClean);
    }
  }


  expire = () => {
    this.expired = true;
    try {
      window.location.href = `${routes.logout(window.location.pathname)}`;
    } catch (e) {
      window.location.reload();
    }
  };


  // Called when there has been no activity for more than warnAfter
  // seconds.
  showWarning = () => {
    this.$warning.fadeIn('slow');
  };


  // Called to hide the warning, for example if there has been activity on
  // the server side - in another browser tab.
  hideWarning = () => {
    this.$warning.hide();
  };


  // Hit the PingView with the number of seconds since last activity.
  ping = () => {
    const idleFor = Math.floor((new Date() - this.lastActivity) / 1000);
    const params = buildURLParamsString({ idleFor });
    ajaxFetch(`${this.pingUrl}${params}`)
      .then(data => {
        if (data === 'logout') return this.expire();
        this.lastActivity = new Date();
        this.lastActivity.setSeconds(this.lastActivity.getSeconds() - data);
        this.apply();
        return false;
      })
      .catch(this.apply);
  };


  // Apply warning or expiry, setup next ping
  apply = () => {
    const idleFor = Math.floor((new Date() - this.lastActivity) / 1000);
    let nextPing;

    // Cancel timeout if any, since we're going to make our own
    clearTimeout(this.timeout);

    if (idleFor >= this.expireAfter) return this.expire();

    if (idleFor >= this.warnAfter) {
      this.showWarning();
      nextPing = this.expireAfter - idleFor;
    } else {
      this.hideWarning();
      nextPing = this.warnAfter - idleFor;
    }

    this.timeout = setTimeout(this.ping, Math.min(nextPing * 1000, SETTIMEOUT_MAXIMUM));
    return false;
  };


  // onbeforeunload handler.
  onBeforeUnload = () => {
    if ($('form[data-dirty]').length && !this.expired) {
      return this.confirmFormDiscard;
    }
    return false;
  };
}
